import Tabs from 'components/tabs/Tabs';
import modulesMap from 'core/modulesMap';
import TabsPage from 'navigation/pages/TabsPage';
class Customer extends TabsPage {
    static pageName = 'Customer';
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        const mmap = { ...modulesMap };
        delete mmap.form;
        delete mmap.productCard;
        return {
            ...mmap,
            tabs: ['.tabs', Tabs]
        };
    }
}
export default Customer;
